var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.drawerVisible,
        "with-header": false,
        size: "600px",
        direction: "rtl",
        "before-close": _vm.handleClose,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.drawerVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "banner-detail-container" }, [
        _c("div", { staticClass: "drawer-header" }, [
          _c("div", { staticClass: "drawer-title" }, [_vm._v("banner详情")]),
          _c("i", {
            staticClass: "el-icon-close close-icon",
            on: { click: _vm.handleClose },
          }),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "detail-content",
          },
          [
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("基本信息")]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [
                  _vm._v("banner名称"),
                ]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.name)),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [
                  _vm._v("所属广告组"),
                ]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.bannerGroupName)),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("选用模板")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.bannerInfo.templateId === 1
                          ? "模板一：1*4 banner位"
                          : _vm.bannerInfo.templateId === 2
                          ? "模板二：1+2 banner位"
                          : _vm.bannerInfo.templateId === 3
                          ? "模板三：2+1 banner位"
                          : _vm.bannerInfo.templateId === 4
                          ? "模板四：单行banner位"
                          : "-"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("组内位置")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.slotKey || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("展示时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(
                    _vm._s(_vm.bannerInfo.startTime) +
                      " 至 " +
                      _vm._s(_vm.bannerInfo.endTime)
                  ),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("权重")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.sort)),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("展示地区")]),
                _c(
                  "div",
                  { staticClass: "item-value" },
                  [
                    _vm.bannerInfo.allArea === 1
                      ? [_vm._v("全部地区")]
                      : _vm.bannerInfo.advertisingAreaVoList &&
                        _vm.bannerInfo.advertisingAreaVoList.length
                      ? [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                _vm.formatAreas(
                                  _vm.bannerInfo.advertisingAreaVoList
                                )
                              ) +
                              "\n            "
                          ),
                        ]
                      : [_vm._v("部分地区")],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("展示渠道")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.formatDisplayChannel(_vm.bannerInfo.displayChannel)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("展示页面")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.bannerInfo.displayPageKey === 0
                          ? "首页"
                          : _vm.bannerInfo.displayPageKey === 1
                          ? "城际出行页"
                          : _vm.bannerInfo.displayPage || "-"
                      ) +
                      "\n          "
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("banner预览"),
              ]),
              _c("div", { staticClass: "preview-box" }, [
                _vm.bannerInfo.templateId === 1
                  ? _c("div", { staticClass: "preview" }, [
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.bannerInfo.marketImgUrl, alt: "" },
                        }),
                      ]),
                      _c("div", [
                        _c("img", {
                          attrs: { src: _vm.bannerInfo.imgUrl, alt: "" },
                        }),
                      ]),
                      _c("div", [_vm._v(_vm._s(_vm.bannerInfo.marketText))]),
                    ])
                  : _c("div", { staticClass: "preview" }, [
                      _c("img", {
                        attrs: { src: _vm.bannerInfo.imgUrl, alt: "" },
                      }),
                    ]),
              ]),
            ]),
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [
                _vm._v("默认广告预览"),
              ]),
              _c("div", { staticClass: "preview-box" }, [
                _vm.bannerInfo.templateId === 1
                  ? _c("div", { staticClass: "preview" }, [
                      _c("div", [
                        _c("img", {
                          attrs: {
                            src: _vm.bannerInfo.defaultMarketImgUrl,
                            alt: "",
                          },
                        }),
                      ]),
                      _c("div", [
                        _c("img", {
                          attrs: {
                            src: _vm.bannerInfo.defaultMarketFontUrl,
                            alt: "",
                          },
                        }),
                      ]),
                      _c("div", [
                        _vm._v(_vm._s(_vm.bannerInfo.defaultMarketText)),
                      ]),
                    ])
                  : _c("div", { staticClass: "preview" }, [
                      _c("img", {
                        attrs: {
                          src: _vm.bannerInfo.defaultMarketImgUrl,
                          alt: "",
                        },
                      }),
                    ]),
              ]),
            ]),
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("页面跳转")]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("跳转页面")]),
                _vm.bannerInfo.pageUrl
                  ? _c(
                      "a",
                      {
                        staticClass: "item-value",
                        staticStyle: { color: "#0a85f8" },
                        attrs: { href: _vm.bannerInfo.pageUrl },
                      },
                      [_vm._v(_vm._s(_vm.bannerInfo.pageUrl || "-"))]
                    )
                  : _c("div", [_vm._v("-")]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("跳转类型")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(
                    _vm._s(_vm.getPageUrlTypeText(_vm.bannerInfo.pageUrlType))
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "section" }, [
              _c("div", { staticClass: "section-title" }, [_vm._v("其他信息")]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("创建人")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.createUser || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("创建时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.createTime || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("审核人")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.auditUser || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("审核时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.auditTime || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("更新人")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.updateUser || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("更新时间")]),
                _c("div", { staticClass: "item-value" }, [
                  _vm._v(_vm._s(_vm.bannerInfo.updateTime || "-")),
                ]),
              ]),
              _c("div", { staticClass: "detail-item" }, [
                _c("div", { staticClass: "item-label" }, [_vm._v("广告状态")]),
                _c(
                  "div",
                  { staticClass: "item-value" },
                  [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.renderStatusTag(_vm.bannerInfo.status).type,
                          size: "small",
                        },
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm.renderStatusTag(_vm.bannerInfo.status).text
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.bannerInfo.status === 2
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("div", { staticClass: "item-label" }, [
                      _vm._v("拒绝原因"),
                    ]),
                    _c("div", { staticClass: "item-value red-text" }, [
                      _vm._v(_vm._s(_vm.bannerInfo.refuseReason || "-")),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }